(function () {
  const FREE_SHIPPING_CENTS = 4500;

  function updateShippingBar(cartTotal) {
    const progress = Math.min(100, Math.round((cartTotal / FREE_SHIPPING_CENTS) * 100));
    const dollars = ((FREE_SHIPPING_CENTS - cartTotal) / 100).toFixed(2);
    const cartDollars = (cartTotal / 100).toFixed(2);
    const thresholdDollars = (FREE_SHIPPING_CENTS / 100).toFixed(2);

    // ── 1. TOP BAR ──────────────────────────────────────────
    const topBar = document.getElementById('free-shipping-bar');
    if (topBar) {
      if (cartTotal >= FREE_SHIPPING_CENTS) {
        topBar.innerHTML = `
         <div class="justFreeShipping">
              <div class="suc-item" style="display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;">
              <span style="font-size:13px; color:#2a7a3b; font-weight:600;">Free shipping unlocked!</span>
              <p>Your order qualifies for free shipping at checkout.</p>
            </div>
           <!---- <span style="font-size:12px; color:#000;">$${cartDollars} / $${thresholdDollars}</span> ---->
          
          <div style="background:#e0e0e0; border-radius:99px; height:5px; overflow:hidden;">
            <div style="width:100%; height:100%; background:#2a7a3b; border-radius:99px; display:block;"></div>
          </div>
        </div>  
        `;
      } else {
        topBar.innerHTML = `
        <div class="justFreeShipping">
          <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:8px;">
            <span style="font-size:13px; color:#000; font-weight:500;">
              Add <strong style="color:#1f466b;">$${dollars}</strong> more for free shipping
            </span>
            <span style="font-size:12px; color:#000;">$${cartDollars} / $${thresholdDollars}</span>
          </div>
          <div style="background:#e0e0e0; border-radius:99px; height:5px; overflow:hidden;">
            <div style="width:${progress}%; height:100%; background:#1f466b; border-radius:99px; display:block; transition:width 0.4s;"></div>
          </div>
          </div>
        `;
      }
    }

    // ── 2. BOTTOM MESSAGE (items ke neeche) ─────────────────
    const bottomMsg = document.getElementById('free-shipping-bottom-msg');
    if (bottomMsg) {
      if (cartTotal >= FREE_SHIPPING_CENTS) {
        bottomMsg.innerHTML = `
          <div style="
            padding: 14px 18px;
            background: #f0faf3;
            border: 1px solid #b6dfc2;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 12px;
          ">
            <div style="
              width: 36px; height: 36px; border-radius: 50%;
              background: #2a7a3b;
              display: flex; align-items: center; justify-content: center;
              flex-shrink: 0;
            ">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17L4 12" stroke="#fff" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div>
              <p style="margin:0; font-size:14px; font-weight:600; color:#1a1a1a;">
                You've unlocked free shipping!
              </p>
              <p style="margin:4px 0 0; font-size:12px; color:#555;">
                Your order qualifies for free shipping at checkout.
              </p>
            </div>
          </div>
        `;
      } else if (progress >= 75) {
        bottomMsg.innerHTML = `
          <div style="
            padding: 14px 18px;
            background: #fffbea;
            border: 1px solid #f0d060;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 12px;
          ">
            <div style="
              width: 36px; height: 36px; border-radius: 50%;
              background: #1f466b;
              display: flex; align-items: center; justify-content: center;
              flex-shrink: 0;
            ">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div>
              <p style="margin:0; font-size:14px; font-weight:600; color:#1a1a1a;">
                Almost there!
              </p>
              <p style="margin:4px 0 0; font-size:12px; color:#555;">
                Just <strong style="color:#1f466b;">$${dollars}</strong> away from free shipping. Add one more item — or pay $15 shipping at checkout.
              </p>
            </div>
          </div>
        `;
      } else if (progress >= 50) {
        bottomMsg.innerHTML = `
          <div style="
            padding: 14px 18px;
            background: #f0f5ff;
            border: 1px solid #c0d0f0;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 12px;
          ">
            <div style="
              width: 36px; height: 36px; border-radius: 50%;
              background: #1f466b;
              display: flex; align-items: center; justify-content: center;
              flex-shrink: 0;
            ">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#fff" stroke-width="2"/>
                <path d="M12 8v4l3 3" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <p style="margin:0; font-size:14px; font-weight:600; color:#1a1a1a;">
                You're more than halfway there!
              </p>
              <p style="margin:4px 0 0; font-size:12px; color:#555;">
                Spend <strong style="color:#1f466b;">$${dollars}</strong> more and ship for free — or pay $15 shipping at checkout.
              </p>
            </div>
          </div>
        `;
      } else if (progress > 0) {
        bottomMsg.innerHTML = `
          <div style="
            padding: 14px 18px;
            background: #f9f9f9;
            border: 1px solid #e5e5e5;
            border-radius: 8px;
            display: flex;
            align-items: center;
            gap: 12px;
          ">
            <div style="
              width: 36px; height: 36px; border-radius: 50%;
              background: #1f466b;
              display: flex; align-items: center; justify-content: center;
              flex-shrink: 0;
            ">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="7" width="20" height="14" rx="2" stroke="#fff" stroke-width="2"/>
                <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>
            <div>
              <p style="margin:0; font-size:14px; font-weight:600; color:#1a1a1a;">
                Good start!
              </p>
              <p style="margin:4px 0 0; font-size:12px; color:#555;">
                Add <strong style="color:#1f466b;">$${dollars}</strong> more to your cart to unlock free shipping — or pay $15 shipping at checkout.
              </p>
            </div>
          </div>
        `;
      } else {
        bottomMsg.innerHTML = '';
      }
    }
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => updateShippingBar(cart.total_price))
      .catch(err => console.warn('Cart fetch failed:', err));
  }

  document.addEventListener('cart:update', fetchCartAndUpdate);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.quantity__button')) setTimeout(fetchCartAndUpdate, 400);
    if (e.target.closest('cart-remove-button')) setTimeout(fetchCartAndUpdate, 700);
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('.quantity__input')) setTimeout(fetchCartAndUpdate, 500);
  });

  function observeCartTotal() {
    document.querySelectorAll('.totals__subtotal-value, .cart-subtotal, .totals__total-value').forEach(el => {
      new MutationObserver(() => setTimeout(fetchCartAndUpdate, 100))
        .observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  const cartDrawer = document.querySelector('cart-drawer, #cart-drawer, .cart-drawer');
  if (cartDrawer) {
    new MutationObserver(() => observeCartTotal())
      .observe(cartDrawer, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    fetchCartAndUpdate();
    observeCartTotal();
  });

// Sirf cart page par interval lagao, baaki pages par nahi
if (window.location.pathname === '/cart') {
  setInterval(fetchCartAndUpdate, 1000);
}

})();